import * as types from "./types";

/*
外部設定で読み込みたいもの
history max
GPS距離閾値
最大表示件数？

 */

export const loader = {
  namespaced: true,

  state: {
    loaded: false
  },
  getters: {
    loaded: (state)=> state.loaded
  },
  mutations: {
    setLoaded(state, loaded) {
      state.loaded = loaded;
    }
  },
  actions: {
    [types.SET_LOADED]({ commit }, isLoaded) {
      commit("setLoaded", isLoaded);
    }
  }
};
